import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_BRANDS, UPDATE_BRANDS } from './constants';

export const getBrands = extendRoutine(createRoutine(GET_BRANDS), ['RESET']);
export const updateBrands = extendRoutine(createRoutine(UPDATE_BRANDS), ['RESET']);
